/**
 * Constantes de la aplicación
 * Monedero Digital NFC
 */

// Configuración de la aplicación
export const APP_CONFIG = {
  NAME: 'Monedero Digital NFC',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENV: process.env.REACT_APP_ENV || 'development',
  SECRET_KEY: process.env.REACT_APP_SECRET_KEY || '',
  ENABLE_SIMULATOR: process.env.REACT_APP_ENABLE_SIMULATOR === 'true',
};

// Límites de transacciones
export const LIMITS = {
  MIN_RECARGA: 1000,
  MAX_RECARGA: 50000,
  MAX_SALDO: 100000,
  MIN_PAGO: 100,
};

// Tipos de transacciones
export const TRANSACTION_TYPES = {
  PAGO: 'pago',
  RECARGA: 'recarga',
};

// Roles de usuario
export const USER_ROLES = {
  VENDEDOR: 'vendedor',
  ADMINISTRADOR: 'administrador',
  ESTUDIANTE: 'estudiante',
};

// Estados de operaciones NFC
export const NFC_STATES = {
  IDLE: 'idle',
  SCANNING: 'scanning',
  READING: 'reading',
  WRITING: 'writing',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Categorías de productos
export const PRODUCT_CATEGORIES = {
  COMIDA: 'comida',
  BEBIDAS: 'bebidas',
  SNACKS: 'snacks',
  PAPELERIA: 'papeleria',
  OTROS: 'otros',
};

// Claves de almacenamiento local
export const STORAGE_KEYS = {
  USER_SESSION: 'nfc_wallet_session',
  TRANSACTIONS: 'nfc_wallet_transactions',
  PRODUCTS: 'nfc_wallet_products',
  STUDENTS: 'nfc_wallet_students',
  CONFIG: 'nfc_wallet_config',
  BACKUP: 'nfc_wallet_backup',
};

// Tipos de errores
export const ERROR_TYPES = {
  NFC_NOT_SUPPORTED: 'NFC_NOT_SUPPORTED',
  NFC_PERMISSION_DENIED: 'NFC_PERMISSION_DENIED',
  NFC_READ_ERROR: 'NFC_READ_ERROR',
  NFC_WRITE_ERROR: 'NFC_WRITE_ERROR',
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  CARD_NOT_FOUND: 'CARD_NOT_FOUND',
  CARD_BLOCKED: 'CARD_BLOCKED',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  DATA_CORRUPTED: 'DATA_CORRUPTED',
  STORAGE_FULL: 'STORAGE_FULL',
  ENCRYPTION_ERROR: 'ENCRYPTION_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  LIMITE_EXCEDIDO: 'LIMITE_EXCEDIDO',
};

// Mensajes de error
export const ERROR_MESSAGES = {
  [ERROR_TYPES.NFC_NOT_SUPPORTED]: {
    title: 'NFC No Soportado',
    message: 'Tu dispositivo no soporta NFC. Usa un dispositivo Android con Chrome.',
    action: 'Ver dispositivos compatibles',
  },
  [ERROR_TYPES.NFC_PERMISSION_DENIED]: {
    title: 'Permisos Denegados',
    message: 'Debes otorgar permisos de NFC para usar esta función.',
    action: 'Otorgar permisos',
  },
  [ERROR_TYPES.INSUFFICIENT_BALANCE]: {
    title: 'Saldo Insuficiente',
    message: 'El estudiante no tiene saldo suficiente para esta compra.',
    action: 'Recargar saldo',
  },
  [ERROR_TYPES.CARD_NOT_FOUND]: {
    title: 'Tarjeta No Registrada',
    message: 'Esta tarjeta NFC no está registrada en el sistema.',
    action: 'Contactar administrador',
  },
  [ERROR_TYPES.INVALID_CREDENTIALS]: {
    title: 'Credenciales Inválidas',
    message: 'Usuario o contraseña incorrectos.',
    action: 'Reintentar',
  },
  [ERROR_TYPES.LIMITE_EXCEDIDO]: {
    title: 'Límite Excedido',
    message: 'El monto excede el límite permitido.',
    action: 'Ajustar monto',
  },
};

// Rutas de la aplicación
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  PAYMENT: '/payment',
  RECHARGE: '/recharge',
  BALANCE: '/balance',
  TRANSACTIONS: '/transactions',
  PRODUCTS: '/products',
};

// Formato de moneda
export const CURRENCY_CONFIG = {
  CODE: 'COP',
  SYMBOL: '$',
  LOCALE: 'es-CO',
};

// Configuración de tiempo de sesión
export const SESSION_CONFIG = {
  TIMEOUT: 30 * 60 * 1000, // 30 minutos
  WARNING_TIME: 5 * 60 * 1000, // 5 minutos antes
};

// Configuración de NFC
export const NFC_CONFIG = {
  SCAN_TIMEOUT: 30000, // 30 segundos
  WRITE_TIMEOUT: 10000, // 10 segundos
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 segundo
};

export default {
  APP_CONFIG,
  LIMITS,
  TRANSACTION_TYPES,
  USER_ROLES,
  NFC_STATES,
  PRODUCT_CATEGORIES,
  STORAGE_KEYS,
  ERROR_TYPES,
  ERROR_MESSAGES,
  ROUTES,
  CURRENCY_CONFIG,
  SESSION_CONFIG,
  NFC_CONFIG,
};
